import { GameResultState } from '@/models/games/pokdeng/GameState';
import {
    PokDengRoadmapData,
    PokDengRoadmapRoundData,
} from '@/models/games/pokdeng/Roadmap';
import {
    PokDengRecord,
    PokDengRoadmapRecord,
} from '../../../models/games/pokdeng';
import { DeckResult } from '../../../models/games/pokdeng/DeckInfo';
import {
    convertPDFResultToDetail,
    GetPDCardsFlush,
    GetPDPointFromPDHandResult,
} from '../../../utils/games/pokdeng';
import { SupportedRecord } from '../../host/models';
import { PokDengRoadMapSingleCellProps } from './hook';

export const getPokDengRecordList = (
    records: SupportedRecord[] | undefined
) => {
    let map: Array<PokDengRoadmapRecord> = new Array<PokDengRoadmapRecord>();
    if (records) {
        for (let i = 0; i < records.length; i++) {
            const record: PokDengRecord = records[i] as PokDengRecord;
            map.push(parsePokDengFResult(record));
        }
    }
    return map;
};

export const parsePokDengFResult = (
    record: PokDengRecord
): PokDengRoadmapRecord => {
    let results: Array<DeckResult>;

    if (record.gameResult && record.gameResult.FResult) {
        results = convertPDFResultToDetail(record.gameResult.FResult);
    } else {
        results = convertPDFResultToDetail('0');
    }

    const item: PokDengRoadmapRecord = {
        fullDeck: record.gameResult?.fullDeck,
        Detail: {
            GameID: record.gameID,
            Result: record.result,
            Shoes: record.shoes,
            Round: record.round,
        },
        PDR_BankerPoint: results[0].handResult,
        PDR_BankerPair: results[0].isPair,

        playerResult: results.slice(1),
    };

    return item;
};
type OwnProp = {
    idx: number;
};
const getRoadmapData = (
    item: PokDengRoadMapSingleCellProps & OwnProp
): PokDengRoadmapData => {
    let type = 0;
    if (!item.isBanker) {
        if (item.gameResult === GameResultState.PDRS_PlayerWin) {
            type += 1 << 0;
        } else if (item.gameResult === GameResultState.PDRS_BankerWin) {
            type += 1 << 1;
        } else if (item.gameResult === GameResultState.PDRS_Tie) {
            type += (1 << 0) | (1 << 1);
        }
    }
    if (item.isPair) {
        type += 1 << 2;
    }
    if (item.isFlush) {
        type += 1 << 3;
    }

    return {
        Point: item.point,
        Type: type,
        Idx: item.idx,
    };
};
export const getBeadRoadRecord = (
    record: SupportedRecord
): PokDengRoadmapRoundData => {
    const result = parsePokDengFResult(record as PokDengRecord);
    let list = new Array<PokDengRoadmapData>();
    if (result) {
        list.push(
            getRoadmapData({
                idx: 0,
                isBanker: true,
                gameResult: GameResultState.PDRS_NoHand,
                point: GetPDPointFromPDHandResult(result.PDR_BankerPoint),
                isPair: result.PDR_BankerPair,
                isFlush: result.fullDeck
                    ? GetPDCardsFlush([
                          result.fullDeck.bankerDeck.card1,
                          result.fullDeck.bankerDeck.card2,
                      ])
                    : false,
            })
        );

        for (let i = 0; i < result.playerResult.length; i++) {
            list.push(
                getRoadmapData({
                    idx: i + 1,
                    isBanker: false,
                    gameResult: result.playerResult[i].resultState,
                    point: GetPDPointFromPDHandResult(
                        result.playerResult[i].handResult
                    ),
                    isPair: result.playerResult[i].isPair,
                    isFlush: result.fullDeck
                        ? GetPDCardsFlush([
                              result.fullDeck.playerDecks[i].card1,
                              result.fullDeck.playerDecks[i].card2,
                          ])
                        : false,
                })
            );
        }
    }

    return { GameID: record.gameID, Result: list };
};
